import React, { useState, useMemo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowRightToBracket } from "react-icons/fa6";
import styles from "../../../assets/scss/TransportHandlers/TransportHandlersBilling.module.scss";
import Pagination from "../../../Components/Common/Pagination";
import { useGetAssetSummaryQuery } from "../../../slices/admin/admin";
import { toast } from "react-toastify";
import { capitalize } from "../../../utils/capitalize";

const AssetTable = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");

  const { data, isLoading, isError, error } =
    useGetAssetSummaryQuery({ search });

  useEffect(() => {
    if (isError) {
      toast.error(error?.data?.message || "Failed to fetch asset summary");
    }
  }, [isError]);

  useEffect(() => {
    setCurrentPage(1);
  }, [search]);

  const assetData = data?.data || [];

  const totalPages = Math.ceil(assetData.length / limit);

  const paginatedData = useMemo(() => {
    const start = (currentPage - 1) * limit;
    return assetData.slice(start, start + limit);
  }, [currentPage, limit, assetData]);

  return (
    <div className={styles.parent}>
      <div className={styles.box}>
        <div className={styles.filterBar}>
          <input
            type="text"
            placeholder="Search..."
            className={styles.searchInput}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <button
            className={styles.clearBtn}
            onClick={() => {
              setSearch('');
              setCurrentPage(1);
            }}
          >
            Clear All
          </button>
        </div>
        <div className={styles.tableWrapper}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Customer Name</th>
                <th>Org Name</th>
                <th>Phone</th>
                <th>Sack Count</th>
                <th>Box Count</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan="6" className={styles.noData}>
                    Loading...
                  </td>
                </tr>
              ) : paginatedData.length > 0 ? (
                paginatedData.map((item) => (
                  <tr key={item._id}>
                    <td>{item.name ? capitalize(item.name) : '-'}</td>
                    <td>{item.storeName ? capitalize(item.storeName) : "-"}</td>
                    <td className="notranslate">{item.phone}</td>
                    <td className="notranslate">{item.totalSackCount}</td>
                    <td className="notranslate">{item.totalBoxCount}</td>
                    <td>
                      <FaArrowRightToBracket
                        onClick={() =>
                          navigate(
                            `/dashboard/AssetView?id=${item._id}&mode=view`,
                            { state: { activeTab: "Asset" } }
                          )
                        }
                        className={styles.icon}
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className={styles.noData}>
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className={styles.paginationContainer}>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />

          <select
            value={limit}
            className={styles.inputsbtn}
            onChange={(e) => {
              setLimit(Number(e.target.value));
              setCurrentPage(1);
            }}
          >
            <option value={10}>10 rows</option>
            <option value={25}>25 rows</option>
            <option value={50}>50 rows</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default AssetTable;